import { render, staticRenderFns } from "./SceneHome.vue?vue&type=template&id=0e72960b&"
import script from "./SceneHome.vue?vue&type=script&lang=js&"
export * from "./SceneHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\immersive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e72960b')) {
      api.createRecord('0e72960b', component.options)
    } else {
      api.reload('0e72960b', component.options)
    }
    module.hot.accept("./SceneHome.vue?vue&type=template&id=0e72960b&", function () {
      api.rerender('0e72960b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SceneHome.vue"
export default component.exports